import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
const comboIncludes = ['Todo lo del Mega Pack 360 (7 tomos + 5 bonos) más:', 'Las civilizaciones de Mesopotamia y Egipto — para entender qué era la historia antes de México', 'Grecia y Roma — el pensamiento que llegó con la Conquista', 'La Edad Media, la Iglesia y el Islam — la España que cruzó el Atlántico', 'El Renacimiento, la Ilustración y las Revoluciones — lo que generó la Independencia mexicana', 'El Imperialismo y las Guerras Mundiales — el contexto del México del siglo XX'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-192">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-193"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-194">
        <div className="text-center mb-10" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-forest" data-id="element-196">
            Elige tu pack
          </h2>
          <p className="text-terracotta font-medium text-sm md:text-base" data-id="element-197">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-198">
          {/* OFERTA 1: MEGA PACK SOLO */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-beige rounded-3xl p-1 relative shadow-md" data-id="element-199">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-ivory border border-beige text-forest font-bold px-5 py-1.5 rounded-full shadow-sm uppercase tracking-wider text-xs" data-id="element-200">
              🏆 Oferta principal
            </div>

            <div className="bg-white rounded-[1.3rem] p-6 md:p-8 text-center" data-id="element-201">
              <h3 className="text-2xl font-serif font-bold text-forest mb-3" data-id="element-202">
                Mega Pack Historia México 360
              </h3>
              <p className="text-sm text-warmgray mb-6 h-10" data-id="element-203">
                Los 7 tomos + 5 bonos estratégicos listos para usar en el aula.
              </p>

              <div className="mb-6" data-id="element-204">
                <span className="text-base text-warmgray line-through block mb-1" data-id="element-205">
                  USD 55,00
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-206">
                  <span className="text-xl text-ink font-medium" data-id="element-207">Hoy:</span>
                  <span className="text-4xl font-bold text-emeraldbtn" data-id="element-208">
                    USD 19,90
                  </span>
                </div>
              </div>

              <Button href="https://ktdgr0-mw.myshopify.com/cart/48135140573402:1" target="_blank" onLinkClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Mega Pack Historia México 360',
                  value: 19.9,
                  currency: 'USD'
                });
              }
            }} className="w-full text-base py-4 px-6 mb-5" data-id="element-209">
                🟡 QUIERO EL MEGA PACK
              </Button>

              <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-[11px] text-warmgray font-medium" data-id="element-210">
                <span className="flex items-center gap-1" data-id="element-211">
                  <Lock size={12} className="text-emeraldbtn" data-id="element-212" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-213">
                  <Zap size={12} className="text-emeraldbtn" data-id="element-214" /> Acceso inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-215">
                  <Shield size={12} className="text-emeraldbtn" data-id="element-216" /> Garantía 7
                  días
                </span>
              </div>
            </div>
          </motion.div>

          {/* OFERTA 2: MEGA PACK + MAESTRO AVANZADO */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_40px_rgba(201,162,75,0.2)]" data-id="element-217">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-white font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-218">
              <Sparkles size={14} data-id="element-219" /> Más elegido · Mejor valor
            </div>

            <div className="bg-white rounded-[1.3rem] p-6 md:p-8 text-center" data-id="element-220">
              <h3 className="text-2xl font-serif font-bold text-green-gradient mb-3" data-id="element-221">
                Mega Pack Historia México 360 + Pack Maestro Avanzado
              </h3>
              <p className="text-sm text-warmgray mb-6" data-id="element-222">
                Llevas el pack completo más la historia del mundo que chocó
                contra México.
              </p>

              <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-ivory border border-beige rounded-xl p-4" data-id="element-223">
                {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-xs text-ink font-medium" data-id="element-224">
                    <Check size={14} className="text-olive shrink-0 mt-0.5" data-id="element-225" />
                    <span data-id="element-226">{item}</span>
                  </li>)}
              </ul>

              <div className="mb-6" data-id="element-227">
                <span className="text-base text-warmgray line-through block mb-1" data-id="element-228">
                  USD 72,90
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-229">
                  <span className="text-xl text-ink font-medium" data-id="element-230">Hoy:</span>
                  <span className="text-4xl font-bold text-emeraldbtn" data-id="element-231">
                    USD 27,90
                  </span>
                </div>
              </div>

              <Button href="https://ktdgr0-mw.myshopify.com/cart/48135386923226:1" target="_blank" onLinkClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Mega Pack 360 + Maestro Avanzado',
                  value: 27.9,
                  currency: 'USD'
                });
              }
            }} className="w-full text-base py-4 px-6 mb-5" data-id="element-232">
                🟡 LLEVAR PACK COMPLETO
              </Button>

              <div className="bg-ivory border border-beige rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-233">
                <Globe className="text-terracotta shrink-0 mt-0.5" size={14} data-id="element-234" />
                <p className="text-[11px] text-warmgray font-medium leading-snug" data-id="element-235">
                  Pagas en tu moneda local. El importe se adapta automáticamente
                  al país desde donde compras.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}